
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetotarkarlicarrental() {



    const cardData =
    {
        keyword: 'Pune to Tarkarli Car Rental Services',
        heading: 'S9 Travels: Pune to Tarkarli Car Rental Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable car rental services for your trip from Pune to Tarkarli. Tarkarli is a beautiful coastal destination in Maharashtra, known for its pristine beaches, clear waters, and water sports. Whether you are planning a relaxing getaway or an adventurous trip, we provide a smooth and hassle-free journey. Tarkarli is approximately 350 km from Pune, with a travel time of around 7 to 8 hours by road. With our well-maintained fleet and professional drivers, you can enjoy a safe and comfortable ride tailored to your preferences.',

        top: 'Top Places to Visit in Tarkarli with S9 Travels',

"topPlaces": [
    {
      "title": "Tarkarli Beach",
      "description": "Tarkarli Beach is the main attraction in Tarkarli, known for its white sand and clear waters. It’s perfect for swimming, sunbathing, or indulging in water sports like parasailing, snorkeling, and jet-skiing. The beach offers a peaceful atmosphere, making it ideal for relaxation and beach lovers."
    },
    {
      "title": "Devbaug Beach",
      "description": "Located near Tarkarli, Devbaug Beach is a quiet and serene spot, perfect for a peaceful retreat. It offers beautiful views of the Arabian Sea and is a great place for a calm day by the shore. The nearby river mouth adds to the scenic beauty of the beach."
    },
    {
      "title": "Sindhudurg Fort",
      "description": "Sindhudurg Fort is a historical fort located on an island off the coast of Tarkarli. The fort, built by Chhatrapati Shivaji Maharaj, offers a glimpse into Maharashtra’s rich history. A boat ride to the fort adds to the adventure, and the fort provides panoramic views of the surrounding sea."
    },
    {
      "title": "Malvan Market",
      "description": "Malvan Market is the place to experience the local culture and shop for fresh seafood, local handicrafts, and souvenirs. It is the perfect spot to explore traditional Malvani cuisine and immerse yourself in the local lifestyle."
    },
    {
      "title": "Tarkarli Backwaters",
      "description": "The Tarkarli Backwaters are an excellent spot for boating and exploring the peaceful waters surrounded by lush greenery. A boat ride along the backwaters offers an opportunity to experience the tranquil beauty of the region and spot local wildlife."
    },
    {
      "title": "Vijaydurg Fort",
      "description": "Vijaydurg Fort is located about 30 km from Tarkarli and is an important historical site. The fort is known for its impressive architecture, strategic location, and historical significance. It’s a great spot for history enthusiasts and provides stunning views of the Arabian Sea."
    },
    {
      "title": "Rock Garden Malvan",
      "description": "The Rock Garden in Malvan is a peaceful garden made entirely from natural rocks. It is located near the sea, providing a serene atmosphere for relaxation. The garden is a great place for a quiet walk, photography, and enjoying the surrounding natural beauty."
    },
    {
      "title": "Nivati Beach",
      "description": "Nivati Beach is a lesser-known and tranquil beach, perfect for those seeking privacy and solitude. The beach is surrounded by hills and offers picturesque views, making it a great spot for unwinding and enjoying the natural beauty of the region."
    },
    {
      "title": "Kolamb Beach",
      "description": "Kolamb Beach is another peaceful beach in the Tarkarli region, known for its scenic views and calm waters. It is perfect for those who prefer a less crowded beach experience and want to enjoy the coastal beauty of Tarkarli in solitude."
    }
],

"services": [
    {
      "name": "Book Pune to Tarkarli Car Rental",
      "description": "Traveling from Pune to Tarkarli? S9 Travels offers reliable car rental services for a smooth and comfortable journey. Whether you’re visiting Tarkarli for the beautiful beaches or a serene vacation, we provide a range of vehicles that suit your needs. Enjoy a hassle-free travel experience with our well-maintained cars and experienced drivers."
    },
    {
      "name": "Pune to Tarkarli Taxi",
      "description": "For a smooth and convenient ride from Pune to Tarkarli, S9 Travels provides taxi services designed for your comfort. Our experienced drivers will ensure you have a safe and pleasant journey, whether you're traveling alone, with family, or in a group. Choose our taxis for a hassle-free and enjoyable trip to Tarkarli Beach."
    },
    {
      "name": "Book Pune to Tarkarli Cab Service",
      "description": "Booking a cab service from Pune to Tarkarli with S9 Travels is simple and easy. We offer convenient booking options and a fleet of well-maintained cabs for a comfortable journey. Whether you need a standard taxi or a luxury ride, we provide personalized services to match your travel preferences and group size."
    },
    {
      "name": "Book Pune to Tarkarli One-Way Taxi",
      "description": "If you’re looking for a one-way taxi from Pune to Tarkarli, S9 Travels has got you covered. We offer one-way taxi services for travelers who prefer a direct ride without the need for a return trip. Enjoy the scenic route to Tarkarli with a reliable and affordable one-way taxi ride."
    },
    {
      "name": "Book Pune to Tarkarli Round Trip",
      "description": "Planning a round trip to Tarkarli? S9 Travels offers flexible round-trip taxi services from Pune to Tarkarli. Whether you're visiting for a day or staying longer, our round-trip services are convenient, ensuring your travel is smooth both ways. Book your round trip taxi with us and enjoy the freedom to explore Tarkarli at your own pace."
    },
    {
      "name": "Book Pune to Tarkarli Car Hire",
      "description": "For those who prefer to explore Tarkarli at their own pace, S9 Travels offers car hire services for Pune to Tarkarli trips. Whether you’re looking for a prefer a driver with you, we provide flexible options to suit your travel style. Our cars are well-maintained, offering comfort and reliability for your journey."
    },
    {
      "name": "Book Pune to Tarkarli Private Taxi",
      "description": "If you prefer a private and personalized experience, S9 Travels offers private taxi services from Pune to Tarkarli. Whether you're traveling solo, with family, or in a group, our private taxis provide the privacy, comfort, and flexibility you need. Relax and enjoy the journey with a dedicated driver who ensures a smooth ride."
    },
    {
      "name": "Book Pune to Tarkarli Efficient Taxi",
      "description": "For those seeking a budget-friendly option, S9 Travels offers Efficient Taxi services from Pune to Tarkarli. Share the ride with others and enjoy the same level of comfort and convenience at a more affordable price. Our Efficient Taxi services are perfect for solo travelers or small groups looking to save on transportation costs."
    },
    {
      "name": "Tarkarli Car Rental Pune",
      "description": "For a convenient Tarkarli car rental from Pune, look no further than S9 Travels. We offer a range of vehicles to cater to your travel needs. Whether you’re looking for an economy car, an SUV, or a luxury vehicle, we provide flexible rental services with competitive pricing. Rent a car and explore Tarkarli at your leisure."
    },
    {
      "name": "Pune to Tarkarli Beach Trip",
      "description": "Looking to visit the stunning Tarkarli Beach from Pune? S9 Travels offers taxi and car rental services for your Tarkarli Beach trip. Whether you're planning a family outing, a romantic getaway, or a solo trip, we ensure you travel comfortably and arrive relaxed. Our drivers are familiar with the best routes, ensuring a quick and pleasant journey to the beach."
    },
    {
      "name": "Tarkarli Private Taxi Service",
      "description": "For a private and comfortable taxi ride to Tarkarli, choose S9 Travels. Our private taxi services are designed to offer you a premium experience with complete privacy, air-conditioned vehicles, and a dedicated driver. Enjoy a peaceful and enjoyable ride to one of the most beautiful beach destinations in Maharashtra."
    },
    {
      "name": "Budget Taxi to Tarkarli",
      "description": "If you’re looking for an affordable taxi service to Tarkarli, S9 Travels offers budget-friendly options without compromising on comfort. Our taxis are well-maintained and driven by professional drivers, ensuring a safe and enjoyable ride at a competitive price. Choose our budget taxi service for an economical yet comfortable journey to Tarkarli."
    },
    {
      "name": "Pune to Tarkarli Road Trip",
      "description": "Embark on an exciting road trip from Pune to Tarkarli with S9 Travels. We offer customized taxi services that allow you to enjoy the scenic drive and the freedom to stop and explore along the way. Whether you're traveling with friends or family, we ensure that your road trip to Tarkarli is smooth, comfortable, and memorable."
    },
    {
      "name": "Affordable Tarkarli Car Hire",
      "description": "Looking for affordable car hire options for your trip to Tarkarli? S9 Travels offers competitive pricing on car rentals from Pune to Tarkarli. Choose from a variety of vehicles that fit your budget and travel style. Our cars are well-maintained and come with reliable drivers, ensuring that your journey is both affordable and comfortable."
    },
    {
      "name": "Luxury Taxi to Tarkarli from Pune",
      "description": "For those who want to travel in style and comfort, S9 Travels offers luxury taxi services to Tarkarli from Pune. Our luxury vehicles are equipped with top-of-the-line features and amenities to ensure a premium travel experience. Relax in comfort as our experienced drivers take you to your destination in style."
    }
],

"tableData": [
  ["Book Pune To Tarkarli Car Rental", "Pune To Tarkarli Taxi"],
  ["Book Pune To Tarkarli Cab Service", "Book Pune To Tarkarli One-Way Taxi"],
  ["Book Pune To Tarkarli Round Trip", "Book Pune To Tarkarli Car Hire"],
  ["Book Pune To Tarkarli Private Taxi", "Book Pune To Tarkarli Efficient Taxi"],
  ["Tarkarli Car Rental Pune", "Pune to Tarkarli Beach Trip"],
  ["Tarkarli Private Taxi Service", "Budget Taxi to Tarkarli"],
  ["Pune to Tarkarli Road Trip", "Affordable Tarkarli Car Hire"],
  ["Luxury Taxi to Tarkarli from Pune", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we prioritize punctuality and reliability. Whether you're heading to Tarkarli for a peaceful beach getaway or a relaxing vacation, our drivers ensure timely pickups and drop-offs, making your trip smooth and hassle-free."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars, for your journey from Pune to Tarkarli. All our vehicles are equipped with air conditioning, comfortable seating, and spacious interiors to ensure a relaxed and pleasant ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and familiar with the best routes to Tarkarli. They ensure a smooth, safe, and enjoyable journey, allowing you to focus on relaxing and enjoying the coastal beauty of Tarkarli."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Tarkarli car rental. There are no hidden charges, and we provide a clear breakdown of costs so you know exactly what to expect. This allows you to plan your trip without any surprises."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking. We ensure you a safe and comfortable journey, giving you peace of mind while traveling to Tarkarli."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you're planning an early morning trip or a late-night return, S9 Travels operates around the clock to meet your needs. Our customer service team is always available to assist with bookings, inquiries, or any other assistance you may require."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Pune to Tarkarli trip is simple and convenient with S9 Travels. You can easily book through our website or mobile app, or you can contact our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're visiting Tarkarli for relaxation, water sports, or sightseeing, we offer customized travel packages tailored to your specific needs. Let us know your preferences, and we’ll ensure that your trip is both memorable and enjoyable."
  }
]






















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Tarkarli car rental with S9 Travels?',
            answer: 'Booking a car is simple! You can book online through our website or app, or you can contact our customer service team for personalized assistance and help with planning your trip.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Tarkarli trip?',
            answer: 'We offer a range of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained and designed to provide comfort and safety during long trips.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Tarkarli?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes to Tarkarli. They ensure a safe, smooth, and enjoyable ride throughout the journey.',
          },
          {
            question: 'How do I pay for my Pune to Tarkarli car rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it convenient for you to pay for your ride.',
          },
          {
            question: 'Can I book a round-trip from Pune to Tarkarli?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we’ll ensure a smooth and comfortable return journey from Tarkarli.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a car for sightseeing in Tarkarli?',
            answer: 'Yes, we offer sightseeing services around Tarkarli. Explore the beautiful beaches, nearby forts, and other attractions with the help of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Tarkarli car rental?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or specific requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Tarkarli?',
            answer: 'Yes, we offer corporate and group travel services to Tarkarli. Whether it\'s a corporate outing or a family trip, we ensure a comfortable and enjoyable experience for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Tarkarli journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth and memorable trip to Tarkarli.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Ramesh Kadam',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a car with S9 Travels for my trip to Tarkarli. The vehicle was clean and comfortable, and the driver was very professional. We had a smooth journey, and Tarkarli was simply breathtaking. Highly recommend S9 Travels!”',
        },
        {
          name: 'Mrs. Shruti Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our visit to Tarkarli was amazing, thanks to S9 Travels. The driver was polite and knowledgeable about the area. The vehicle was spacious and clean, making our trip comfortable. We\'ll definitely book again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Tarkarli Car Rental",
        "description": "Book Pune to Tarkarli car rental services with S9 Travels. We offer one-way taxis, round trips, luxury taxis, and car hire options for your Tarkarli beach trip. Choose private taxis or for a budget-friendly road trip or private tour from Pune to Tarkarli, with the best fares for car rental and sightseeing services.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      
      
      
      


    return (
        <div>
         <Helmet>
        <title>Pune To Tarkarli Car Rental | Affordable Taxi & Car Hire | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Tarkarli car rental, one-way taxi, round-trip, luxury taxi, and Efficient Taxi services with S9 Travels. Get the best rates for your Tarkarli beach trip, private taxi service, road trip, and car hire from Pune." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/27.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetotarkarlicarrental;